/**
 * @generated SignedSource<<c504adcc14b67a6f86b1a3d8bb952c57>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type MilestoneRowMetadata$data = {
  readonly issues: {
    readonly totalCount: number;
  };
  readonly progressPercentage: number;
  readonly " $fragmentSpreads": FragmentRefs<"MilestoneRowMenu">;
  readonly " $fragmentType": "MilestoneRowMetadata";
};
export type MilestoneRowMetadata$key = {
  readonly " $data"?: MilestoneRowMetadata$data;
  readonly " $fragmentSpreads": FragmentRefs<"MilestoneRowMetadata">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MilestoneRowMetadata",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MilestoneRowMenu"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "progressPercentage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IssueConnection",
      "kind": "LinkedField",
      "name": "issues",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Milestone",
  "abstractKey": null
};

(node as any).hash = "3f96a73780e426343e511b1fbe18c5df";

export default node;
